// extracted by mini-css-extract-plugin
export default {"listingAge":"ListingAge-module__listingAge___XEMva","dateAgo":"ListingAge-module__dateAgo___YepG2","strikeThrough":"ListingAge-module__strikeThrough___Vas6A"};